import { Head } from "react-static";

const MetaCard = ({
  title,
  description,
  cardtext,
  navlink,
  cardimg,
  cardbtntext,
}) => {
  return (
    <Head>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:image" content={cardimg} />
      <link rel="icon" type="image/x-icon" href={cardimg} />
      <link href={cardimg} title={cardimg} />
      <meta name="og:description" content={cardtext} />
      <link href={navlink} title={navlink} />
      <meta name="og:description" content={cardbtntext} />
    </Head>
  );
};

export default MetaCard;
